import React from "react";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "./Generic/AppCard";

interface Props {
  questionText: string;
  imgUrl: string;
}

const RequiredDocImage = (props: Props) => {
  return (
    <AppCard className="RequiredDocImage">
      <AppCardHeader>
        <AppCardTitle>{props.questionText}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <img src={props.imgUrl} alt="" className="ScheduledVisitDocScreen__image" />
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(RequiredDocImage);
